.sidebar-container {
    display: flex;
    flex-direction: column;
    position: absolute;
    right: -300px;
    top: 0;
    width: 300px;
    overflow-x: hidden;
}

.sidebar-modal-overlay {
    content: '';
    position: absolute;
    top: 0;
    /* Don't hide the border-left */
    right: 0;
    width: 4px;
    height: 4px;
    background-color: white;
    z-index: 1000;
}

.sidebar {
    border-radius: 0 8px 8px 0;
    background-color: white;
    animation: slideIn 0.2s ease-in-out;
    min-height: 250px;
    border-left: 1px solid var(--off-white-dk);
}

.sidebar-header {
    padding: 8px 16px 8px 16px;
    border-bottom: 1px solid var(--off-white-dk);
}

.peep-result:last-child {
    border-bottom-right-radius: 8px;
}

.peep-result:hover {
    background-color: var(--off-white-dk);
}

.results-container {
    max-height: 450px;
    overflow-y: auto;
}

.results-loading {
    opacity: 0.6;
    transition: opacity 0.2s ease;
}

@keyframes slideIn {
    from {
        opacity: 0;
        transform: translateX(-30%);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.empty-state-container {
    /* Full height - header height */
    height: calc(250px - 38px);
    display: flex;
    align-items: center;
    justify-content: center;
}

.tertiary-info {
    font-size: var(--font-tiny);
    margin: -10px 16px 0 56px;
    padding-bottom: 12px;
    color: var(--grey);
    overflow: hidden;
    text-overflow: ellipsis;
}
